<template>
  <div class="header">
    <!-- Logo (po kliknięciu przenosi na stronę główną) -->
    <div :class="['logo', { 'logo--sg': shouldHideLocation }]">
      <router-link to="/"></router-link>
    </div>
    <div :class="['banner', { 'banner--sg': isSG, 'banner--posg': isPOSG, 'banner--nosg': isNOSG }]"></div>
    <div class="additional-menu">
      <!-- Widget feedback  (np. zgłaszanie błędów) -->
<!--      <div id="feedback-form" v-if="hasAccess('Tickets')"></div>-->
      <div class="d-flex">
        <!-- Ikona zgłaszania problemu (report), widoczna tylko dla uprawnionych -->
        <span
          class="report"
          @click="openReportModal"
          v-if="hasAccess('Tickets') && !shouldHideLocation"
          :title="t('open-report-form')"
        >!</span>
        <!-- Ikona głośności: pozwala włączać/wyłączać dźwięki nowego pojazdu -->
        <span
          class="volume"
          :class="{ 'is-mute': this.mute }"
          @click="toggleVolume(this.mute)"
          :title="t('mute-new-vehicle-sound')"
        ></span>
        <!-- Przejście do ustawień/prerferencji użytkownika -->
        <router-link
          v-if="hasAccess('SelfConfig')"
          class="settings"
          to="/preference"
          :title="t('settings')"
        >{{ hasAccess("SelfConfig") ? "" : t('preferences') }}</router-link>
        <!-- <router-link v-if="hasAccess('UsersAdmin')" class="users" to="/users"
          >{{ hasAccess("UsersAdmin") ? "" : "Użytkownicy" }}
        </router-link> -->
        <!-- Wylogowanie -->
        <router-link class="logout" to="/logout">{{ t('logout') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { useUserStore } from "@/stores/user.store";
import CurrentMeasurementsService from "@/services/CurrentMeasurementsService";
import { useErrorStore } from "@/stores/error.store";
import { isSG, isNOSG, isPOSG } from "@/config/appVersion";
import { computed } from "vue";
import { i18n} from "@/main";
import {useI18n} from "vue-i18n";

export default {
  setup() {
    // Store do obsługi globalnych błędów
    const errorStore = useErrorStore();

    const shouldHideLocation = computed(() => {
      return isSG;
    });

    const userStore = useUserStore();

    const { t } = useI18n();

    return { errorStore, shouldHideLocation, userStore, t, isSG, isNOSG, isPOSG };
  },
  data() {
    return {
      mute: false, // czy dźwięk nowego pojazdu jest wyciszony?
      vehService: CurrentMeasurementsService, // dostęp do obsługi dźwięku
    };
  },
  methods: {
    // Sprawdza, czy aktualny użytkownik ma dany typ dostępu (np. do , ustawień, itp.)
    hasAccess(id) {
      return this.userStore.hasAccess(id);
    },
    // Przełącza wyciszenie dźwięków
    toggleVolume(flag) {
      this.mute = !flag;
      this.vehService.beepToggle(this.mute);
    },
    // Otwiera modal do zgłaszania błędu/problemów (po kliknięciu "!" jeśli uprawnienia pozwalają)
    openReportModal() {
      const title = i18n.global.t('report-error');
      const describeError = i18n.global.t('describe-error');
      const sendLabel = i18n.global.t('send');

      // Pokazuje globalny modal - prosty formularz tekstowy
      window.$modal.showModal(title, {
        template: `
          <div>
            <form @submit.prevent="submitForm">
              <label for="report">${describeError}:</label>
              <textarea id="report" v-model="report"></textarea>
              <button type="submit">${sendLabel}</button>
            </form>
          </div>
        `,
        data() {
          return {
            report: "",
          };
        },
        methods: {
          submitForm() {
            // Tu możesz dodać obsługę wysyłania do API!
            window.$modal.hideModal();
          },
        },
      });
    },
  },
};
</script>

<style scoped>
.header {
  display: flex;
  height: 152px;
  background-color: #f3f2ef;
}

.logo {
  width: 284px;
  height: 100%;
  position: relative;
  background: #f5f4f2 url("../assets/logo.png") no-repeat center;
  box-shadow: 1px 1px 5px #bfbfbf;
}

.logo a {
  display: block;
  width: 100%;
  height: 100%;
}

.logo--sg {
  background: #f5f4f2 url("../assets/best2.png") no-repeat center;
}

.banner {
  width: 702px;
  height: 100%;
  background: #f5f4f2 url("../assets/baner5.jpg") no-repeat center;
}

.banner--sg {
  background: #f5f4f2 url("../assets/baner8.jpeg") no-repeat center;
  background-size: auto 101%;
  background-position: left 0px;
}

.banner--nosg {
  background: #f5f4f2 url("../assets/baner8.jpeg") no-repeat center;
  background-size: auto 101%;
  background-position: left 0px;
}

.banner--posg {
  background: #f5f4f2 url("../assets/baner7.jpeg") no-repeat center;
  background-size: auto 101%;
  background-position: left 0px;
}

a {
  font-weight: bold;
  color: #2c3e50;
}

a.router-link-exact-active {
  color: #42b983;
}

.additional-menu {
  margin: 20px;
  width: 255px;
}

.additional-menu > div {
  margin-bottom: 30px;
  justify-content: end;
}

.settings {
  position: relative;
  height: 25px;
  min-width: 54px;
  text-decoration: none;
  color: #58585a;
  border-right: 1px solid #bfbfbf;
}

.settings:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 25px;
  background: url("../assets/icons/preferencje.png") no-repeat center top;
}

.settings:hover {
  color: black;
}

.settings:hover:before {
  background: url("../assets/icons/preferencje_over.png") no-repeat center top;
}

.report {
  padding-right: 1rem;
  height: 25px;
  text-decoration: none;
  color: #58585a;
  border-right: 1px solid #bfbfbf;
  cursor: pointer;
}

.volume {
  position: relative;
  height: 25px;
  min-width: 54px;
  text-decoration: none;
  color: #58585a;
  border-right: 1px solid #bfbfbf;
  cursor: pointer;
}
.volume:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 25px;
  filter: invert(38%) sepia(5%) saturate(178%) hue-rotate(201deg)
    brightness(83%) contrast(85%);
  background: url("../assets/icons/volume-up.svg") no-repeat center top;
  background-size: 25px 25px;
}
.volume.is-mute:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 25px;
  filter: invert(38%) sepia(5%) saturate(178%) hue-rotate(201deg)
    brightness(83%) contrast(85%);
  background: url("../assets/icons/volume-mute.svg") no-repeat center top;
  background-size: 25px 25px;
}

.users {
  border-right: 1px solid #bfbfbf;
  min-width: 54px;
}

.users,
.logout {
  position: relative;
  height: 25px;
  text-decoration: none;
  color: #58585a;
}

.logout {
  min-width: 90px;
  padding-left: 40px;
}

.users:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 25px;
  background: url("../assets/icons/uzytkownicy.png") no-repeat center top;
}

.users:hover {
  color: black;
}

.users:hover:before {
  background: url("../assets/icons/uzytkownicy_over.png") no-repeat center top;
}

.logout:before {
  content: "";
  position: absolute;
  left: 10px;
  top: 0;
  width: 30px;
  height: 25px;
  background: url("../assets/icons/wyloguj.png") no-repeat left top;
}

.logout:hover {
  color: black;
}

.logout:hover:before {
  background: url("../assets/icons/wyloguj_over.png") no-repeat left top;
}

</style>
